export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/iphone-93bf868b6b463c59ea0ecc8242cb0777.png";